import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'irmg_bk-only-for-qa': {
    '/:brand/product': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'irmg_bk/product',
      },
    },
  },
}

export default demo
